import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Employeetransportserviceinpune() {



  const cardData =
  {
    keyword: ' Employee Transport Services in Pune ',
    heading: 'Pune Corporate Cars India Private Limited: Employee Transport Services in Pune  ',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and efficient Employee Transport Services in Pune, designed to meet the daily travel needs of corporate offices, IT parks, industrial units, and business centers across the city. Our fleet of well-maintained sedans, SUVs, MUVs, and buses ensures safe, comfortable, and punctual transportation for employees across multiple shifts and routes. Whether it is daily staff commute, shift-based movement, inter-office travel, last-mile connectivity, or long-term corporate contracts, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, GPS-enabled vehicles, flexible rental plans, real-time tracking, and dedicated service support, Pune Corporate Cars India Private Limited ensures a smooth, dependable, and professional travel experience for employees and organizations throughout Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

"topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
  {
    "name": "Employee Shuttle Pune",
    "description": "Employee Shuttle Pune provides structured shuttle services for daily workforce commuting. With AC buses and vans, GPS tracking, and professional drivers, it ensures punctual and safe transport for employees across corporate locations in Pune."
  },
  {
    "name": "Staff Transportation Pune",
    "description": "Staff Transportation Pune offers organized transport solutions for corporate employees, including daily commute, multi-shift support, and optimized routes. It guarantees safety, reliability, and timely pickups and drops for all staff members."
  },
  {
    "name": "Office Pickup Drop Pune",
    "description": "Office Pickup Drop Pune provides convenient, pre-scheduled transportation for employees between their homes and offices. Features include route optimization, real-time tracking, and trained drivers for a seamless commute experience."
  },
  {
    "name": "IT Company Employee Transport Pune",
    "description": "IT Company Employee Transport Pune caters specifically to IT campuses, offering daily commute services for employees with flexible scheduling, GPS monitoring, and professional drivers to ensure safe and timely travel."
  },
  {
    "name": "Corporate Staff Bus Service Pune",
    "description": "Corporate Staff Bus Service Pune delivers high-capacity shuttle services for bulk staff movement. With AC buses, fixed and rotating shifts, and real-time tracking, it is ideal for companies managing large employee fleets."
  },
  {
    "name": "Daily Employee Commute Pune",
    "description": "Daily Employee Commute Pune provides reliable daily transport for employees, featuring scheduled pickups and drops, GPS-enabled monitoring, and professional drivers to ensure consistent and safe commuting."
  },
  {
    "name": "Corporate Shuttle Service Pune",
    "description": "Corporate Shuttle Service Pune offers flexible and secure shuttle operations for employees traveling between multiple office locations or industrial hubs. It emphasizes safety, punctuality, and route optimization."
  },
  {
    "name": "Employee Mobility Pune",
    "description": "Employee Mobility Pune delivers comprehensive workforce mobility solutions including daily commutes, inter-office transfers, and multi-shift support with GPS tracking and trained chauffeurs to streamline employee transport."
  },
  {
    "name": "Workforce Transport Pune",
    "description": "Workforce Transport Pune provides scalable transport services for corporate staff, including shuttle vans, buses, and cab services. It ensures safe, timely, and efficient movement of employees across Pune's business hubs."
  },
  {
    "name": "Company Staff Cab Pune",
    "description": "Company Staff Cab Pune offers dedicated corporate cab services for employees and executives, featuring sedans, SUVs, professional drivers, GPS tracking, and flexible routes to meet corporate travel needs."
  },
  {
    "name": "Shared Employee Transport Pune",
    "description": "Shared Employee Transport Pune provides cost-effective commuting solutions where multiple employees share cab or shuttle services. It maximizes efficiency while maintaining comfort, safety, and reliability."
  },
  {
    "name": "Night Shift Employee Transport Pune",
    "description": "Night Shift Employee Transport Pune ensures safe and secure transport for employees working late or overnight shifts. Services include GPS-enabled vehicles, trained drivers, and dedicated support for night operations."
  },
  {
    "name": "Secure Employee Transport Pune",
    "description": "Secure Employee Transport Pune focuses on safety and compliance, offering monitored rides, trained drivers, real-time tracking, and emergency support for corporate staff commuting in Pune."
  },
  {
    "name": "Affordable Staff Transport Pune",
    "description": "Affordable Staff Transport Pune provides budget-friendly yet reliable corporate transport solutions for employees, balancing cost efficiency with safety, punctuality, and comfortable commuting options."
  },
  {
    "name": "Employee Pickup Drop Cab Pune",
    "description": "Employee Pickup Drop Cab Pune offers dedicated cab services for employee travel, with professional drivers, GPS tracking, and flexible pick-up and drop options to accommodate various corporate schedules."
  }
],

"tableData": [
  ["Employee Shuttle Pune", "Staff Transportation Pune"],
  ["Office Pickup Drop Pune", "IT Company Employee Transport Pune"],
  ["Corporate Staff Bus Service Pune", "Daily Employee Commute Pune"],
  ["Corporate Shuttle Service Pune", "Employee Mobility Pune"],
  ["Workforce Transport Pune", "Company Staff Cab Pune"],
  ["Shared Employee Transport Pune", "Night Shift Employee Transport Pune"],
  ["Secure Employee Transport Pune", "Affordable Staff Transport Pune"],
  ["Employee Pickup Drop Cab Pune", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Employee Transport Services in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable employee transport services in Pune, ensuring safe and efficient commuting for corporate employees across offices, industrial zones, and business hubs."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We provide punctual pickups and drop-offs across Pune, helping employees reach offices and industrial areas on time, every day."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs ensure safe, courteous, and disciplined travel, delivering a secure and comfortable commuting experience for employees."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable employee transport in Pune."
  },
  {
    "WhyChooseheading": "Customized Corporate Transport Solutions",
    "WhyChoosedescription": "We provide flexible and tailored transport plans to meet the specific commuting needs of companies and employees in Pune."
  },
  {
    "WhyChooseheading": "24/7 Transport Support",
    "WhyChoosedescription": "Our team offers round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted employee transport services."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, offering secure and hygienic rides for employees."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Employee transport is streamlined through our easy booking system and reliable coordination, making daily commuting hassle-free."
  }
]




















  }

  
const faqData = [
  {
    question: 'Do you provide employee transport services in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional employee transport services for companies across Pune.',
  },
  {
    question: 'What types of employee transportation services are available in Pune?',
    answer: 'We provide daily employee commutes, shuttle services, corporate pickups and drops, airport transfers, and flexible transport solutions tailored to company needs.',
  },
  {
    question: 'Do you support multi-shift and rotational employee transport in Pune?',
    answer: 'Yes, we offer structured transport solutions for early morning, night shifts, and rotational schedules to ensure timely employee commute.',
  },
  {
    question: 'How can companies book employee transport services in Pune?',
    answer: 'Bookings can be made via our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for employee transport services in Pune?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, and luxury vehicles based on employee strength and company requirements.',
  },
  {
    question: 'Do you offer long-term employee transport contracts in Pune?',
    answer: 'Yes, we provide monthly, quarterly, and annual employee transport contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are the vehicles GPS-enabled and safety compliant?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide transport for corporate events and outstation employee travel?',
    answer: 'Absolutely. We provide reliable transport solutions for corporate events, team outings, and intercity employee travel.',
  },
  {
    question: 'What payment options are available for employee transport services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ankit Deshmukh',
    feedback: 'Highly dependable employee transport service in Pune. Vehicles are punctual, safe, and comfortable for all employees.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Patil',
    feedback: 'Excellent employee transportation partner. Timely pickups and professional drivers make commuting hassle-free for our staff.',
    rating: 5,
  },
];


















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Employee Transport Services in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/employee-transport-pune.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited offers reliable and efficient Employee Transport Services in Pune, including office pickup and drop, IT company employee transport, corporate staff bus services, daily employee commute, corporate shuttle services, workforce transport, shared employee transport, night shift employee transport, secure and affordable employee transport solutions for companies operating in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/employee-transport-services-pune"
  }
};







  return (
    <div>
<Helmet>
  <title>Employee Transport Services in Pune | Office Pickup & Drop, Staff Shuttle</title>

  <meta
    name="description"
    content="Reliable Employee Transport Services in Pune offering office pickup & drop, IT company employee transport, corporate staff bus services, daily employee commute, shared employee transport, night shift transport, and secure, affordable transport for workforce mobility."
  />

  <meta
    name="keywords"
    content="Employee Shuttle Pune, Staff Transportation Pune, Office Pickup Drop Pune, IT Company Employee Transport Pune, Corporate Staff Bus Service Pune, Daily Employee Commute Pune, Corporate Shuttle Service Pune, Employee Mobility Pune, Workforce Transport Pune, Company Staff Cab Pune, Shared Employee Transport Pune, Night Shift Employee Transport Pune, Secure Employee Transport Pune, Affordable Staff Transport Pune, Employee Pickup Drop Cab Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/104.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Employeetransportserviceinpune;